import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../contexts/AuthContext";
import { apiClient } from "../lib/api";

/**
 * Centralized hook for quota status data
 * Single source of truth for quota information across the entire app
 */
export function useQuotaStatus() {
    const { user } = useAuth();

    return useQuery({
        queryKey: ["quota-status"],
        queryFn: () => apiClient.getQuotaStatus(),
        enabled: !!user,
        retry: 2,
    });
}
